import { Injectable } from '@angular/core';
import Rollbar from 'rollbar';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RollbarService {
  private rollbar: Rollbar;

  constructor() {
    this.rollbar = new Rollbar({
      accessToken: environment.rollbarTracker.accessToken,
      captureUncaught: true,
      captureUnhandledRejections: true,
      payload: {
        environment: environment.production ? 'production' : 'development'
      },
      checkIgnore: (isUncaught: boolean, args: unknown[], payload: any) => {
        try {
          // message is usually a string inside payload.body.message.body
          const message: string = String(payload?.body?.message?.body || '');

          // errorObj could be anything (Error, HttpErrorResponse, string, etc.)
          const errorObj = args && args.length > 0 ? args[0] as any : null;

          // Ignore expected 401/403 or known unauthenticated errors
          if (
            (typeof message === 'string' && message.includes('403')) ||
            message.includes('User is not Authenticated') ||
            (message.includes('Http failure response for') && message.includes('403')) ||
            ([401, 403].includes(Number(errorObj?.status)))
          ) {
            // console.error('Warning: Suppressing Rollbar log for expected error:', message);
            return true; // Ignore (don’t log to Rollbar)
          }
        } catch (e) {
          console.error('Rollbar checkIgnore failed', e);
        }
        // console.log('Rollbar logging error:', args);
        return false; // Log everything else
      }
    });
  }

  info(msg: string, extra?: any) {
    if(environment.production) {
      this.rollbar.info(msg, extra);
    }
  }

  warn(msg: string, extra?: any) {
    if(environment.production) {
      this.rollbar.warning(msg, extra);
    }
  }

  error(err: any, extra?: any) {
    if(environment.production) {
      this.rollbar.error(err, extra);
    }
  }

  configure(payload: any) {
    this.rollbar.configure({ payload });
  }

  getInstance() {
    return this.rollbar;
  }

}
